import { render, staticRenderFns } from "./DamageStatusBadge.vue?vue&type=template&id=dded9b28"
import script from "./DamageStatusBadge.vue?vue&type=script&lang=ts"
export * from "./DamageStatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./DamageStatusBadge.vue?vue&type=style&index=0&id=dded9b28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports